import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { Tooltip } from "./common/tooltip.js";
/**
 * A creatable button is next to the headline. The use case for
 * a creatable button is for example the "Create folder" button.
 *
 * @returns
 */ export const Creatable = ({ visible = true, type, cssClasses, isCreatableLinkDisabled, toolTipTitle, toolTipText, icon, label, onClick })=>{
    if (!visible) return null;
    const className = classNames(cssClasses, {
        "aiot-disabled": isCreatableLinkDisabled
    });
    const body = /*#__PURE__*/ _jsxs("button", {
        "data-aio-type": type,
        className: className,
        onClick: ()=>onClick && onClick(type),
        children: [
            icon,
            " ",
            label
        ]
    });
    return toolTipTitle ? /*#__PURE__*/ _jsx(Tooltip, {
        title: toolTipTitle,
        content: toolTipText,
        children: body
    }) : body;
};
